import { getCookie, setCookie } from "react-use-cookie";
import { SignupCookieData } from "../../../types/signupAttribution";

export const SIGNUP_COOKIES_NAME = "consensus_signup_cookies";

/**
 * Retrieves stored signup attribution data
 */
export function getSignupAttribution(): SignupCookieData | null {
  try {
    const cookieValue = getCookie(SIGNUP_COOKIES_NAME);
    return cookieValue ? JSON.parse(cookieValue) : null;
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error("Error parsing signup attribution cookie:", error);
    }
    return null;
  }
}

/**
 * Clears signup attribution data (called after successful signup)
 */
export function clearSignupAttribution(): void {
  setCookie(SIGNUP_COOKIES_NAME, "", { days: -1 });

  if (process.env.NODE_ENV === "development") {
    console.log("Signup attribution cleared");
  }
}
